import { render, staticRenderFns } from "./events.vue?vue&type=template&id=66453bd4&"
import script from "./events.vue?vue&type=script&lang=js&"
export * from "./events.vue?vue&type=script&lang=js&"
import style0 from "./events.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports